export default __webpack_public_path__ + "static/media/dropdownEdit.b8458251.svg";